// NGRX
import { createFeatureSelector, createSelector } from '@ngrx/store';
// Lodash
import { each } from 'lodash-es';
// CRUD
import { QueryResultsModel } from '../../_base/crud';
// State
import { PatientInsuranceState } from '../_reducers/patient-insurance.reducers';
import { PatientInsuranceModel } from '../_models/patient-insurance.model';

export const selectPatientInsuranceState =
  createFeatureSelector<PatientInsuranceState>('patientInsurance');

export const selectPatientInsuranceById = (PatientInsuranceId: number) =>
  createSelector(
    selectPatientInsuranceState,
    (patientInsuranceState) => patientInsuranceState.entities[PatientInsuranceId],
  );

export const selectPatientInsurancePageLoading = createSelector(
  selectPatientInsuranceState,
  (patientInsuranceState) => patientInsuranceState.listLoading,
);

export const selectPatientInsuranceActionLoading = createSelector(
  selectPatientInsuranceState,
  (patientInsuranceState) => patientInsuranceState.actionsloading,
);

export const selectLastCreatedPatientInsuranceId = createSelector(
  selectPatientInsuranceState,
  (patientInsuranceState) => patientInsuranceState.lastCreatedPatientInsuranceId,
);

export const selectPatientInsuranceErrorState = createSelector(
  selectPatientInsuranceState,
  (patientInsuranceState) => patientInsuranceState.error,
);

export const selectPatientInsuranceShowInitWaitingMessage = createSelector(
  selectPatientInsuranceState,
  (patientInsuranceState) => patientInsuranceState.showInitWaitingMessage,
);

export const selectPatientInsuranceInStore = createSelector(
  selectPatientInsuranceState,
  (patientInsuranceState) => {
    const items: PatientInsuranceModel[] = [];
    each(patientInsuranceState.ids, (ele) => {
      const index: number = +ele;
      items.push(patientInsuranceState.entities[index]);
    });
    return new QueryResultsModel(items, patientInsuranceState.totalCount);
  },
);
